import { userConstants as constants } from '../constants';
import {act} from "react-dom/test-utils";

let user = JSON.parse(localStorage.getItem('user'));
const initialState = user ?
    {
        loggedIn: true,
        loggingIn: false,
        user
    }
    :
    {
        loggedIn: false,
        loggingIn: false,
        user: null
    };

export const authentication = (state, action) => {
    state = state || initialState;

    if (action.type === constants.LOGIN_REQUEST) {
        return {
            ...state,
            loggedIn: false,
            loggingIn: true,
            user: action.user
        };
    }

    if (action.type === constants.LOGIN_SUCCESS) {
        return {
            ...state,
            loggedIn: true,
            loggingIn: false,
            user: action.user
        };
    }

    if (action.type === constants.LOGIN_FAILURE) {
        return {
            ...state,
            loggedIn: false,
            loggingIn: false,
            user: null
        };
    }

    if (action.type === constants.LOGOUT) {
        return {
            ...state,
            loggedIn: false,
            loggingIn: false,
            user: null
        };
    }

    // ### LINK EMAIL ###
    if (action.type === constants.LINK_EMAIL_REQUEST) {
        return {
            ...state,
            linkEmailStatus: action.type
        };
    }

    if (action.type === constants.LINK_EMAIL_SUCCESS) {
        return {
            ...state
        };
    }
    
    if (action.type === constants.LINK_EMAIL_USER_EXISTS) {
        return {
            ...state,
            linkEmailStatus: action.type
        };
    }
    
    if (action.type === constants.LINK_EMAIL_OTHER_LOGIN_CONNECTION_EXISTS) {
        return {
            ...state,
            connectionNames: action.connectionNames,
            linkEmailStatus: action.type
        };
    }

    if (action.type === constants.LINK_EMAIL_FAILURE) {
        return {
            ...state
        };
    }

    // ### GET CONNECTION NAMES FROM EMAIL ###
    if (action.type === constants.GET_CONNECTION_NAMES_REQUEST) {
        return {
            ...state
        };
    }

    if (action.type === constants.GET_CONNECTION_NAMES_SUCCESS) {
        return {
            ...state, 
            connectionNames: action.connectionNames
        };
    }

    if (action.type === constants.GET_CONNECTION_NAMES_FAILURE) {
        return {
            ...state
        };
    }
    
    
    return state;
};


// WEBPACK FOOTER //
// ./src/reducers/authentication.reducer.js